// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 774) return "css-new/framework.css";
	// return url for filenames based on template
	return "css-new/" + chunkId + "-" + {"57":"b832a1","101":"67f2b4","628":"29ee03"}[chunkId] + ".css";
};